import Icon from '../components/Icon.vue'

Icon.register({
  hotel: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 64C568.8 64 576 56.8 576 48V16C576 7.2 568.8 0 560 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H32V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H256V432C256 423.2 263.2 416 272 416H304C312.8 416 320 423.2 320 432V512H560C568.8 512 576 504.8 576 496V464C576 455.2 568.8 448 560 448H544V64H560zM256 108.8C256 102.4 262.4 96 268.8 96H307.2C313.6 96 320 102.4 320 108.8V147.2C320 153.6 313.6 160 307.2 160H268.8C262.4 160 256 153.6 256 147.2V108.8zM256 204.8C256 198.4 262.4 192 268.8 192H307.2C313.6 192 320 198.4 320 204.8V243.2C320 249.6 313.6 256 307.2 256H268.8C262.4 256 256 249.6 256 243.2V204.8zM128 108.8C128 102.4 134.4 96 140.8 96H179.2C185.6 96 192 102.4 192 108.8V147.2C192 153.6 185.6 160 179.2 160H140.8C134.4 160 128 153.6 128 147.2V108.8zM179.2 256H140.8C134.4 256 128 249.6 128 243.2V204.8C128 198.4 134.4 192 140.8 192H179.2C185.6 192 192 198.4 192 204.8V243.2C192 249.6 185.6 256 179.2 256zM192 384C192 331 235 288 288 288S384 331 384 384H192zM448 243.2C448 249.6 441.6 256 435.2 256H396.8C390.4 256 384 249.6 384 243.2V204.8C384 198.4 390.4 192 396.8 192H435.2C441.6 192 448 198.4 448 204.8V243.2zM448 147.2C448 153.6 441.6 160 435.2 160H396.8C390.4 160 384 153.6 384 147.2V108.8C384 102.4 390.4 96 396.8 96H435.2C441.6 96 448 102.4 448 108.8V147.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hotel.js
// module id = YZZ1
// module chunks = 144